<template>
    <div class="message-bottom-actions">
        <ActionButton
          @click="onActionClick('reply')"
          icon='fas fa-reply'
          class='clear'
          text="messages.open.reply"
        />

        <ActionButton v-if="message.recipients.count > 1"
          @click="onActionClick('reply_all')"
          icon='fas fa-reply-all'
          class='clear'
          text='messages.open.reply_all'
        />

        <ActionButton
        @click="onActionClick('forward')"
          icon='fas fa-share'
          class='clear'
          text="messages.open.forward"
        />
    </div>
</template>

<script setup>
  import { defineProps } from 'vue';
  import ActionButton    from '@/vue/Elements/Buttons/ActionButton.vue';

  const props = defineProps({
    webmail_view : {},
    message      : {},
    folder_id    : {}
  })

  const onActionClick = (action) => {
    props.webmail_view.routeTo('/compose', {
      action : action,
      mbox   : props.folder_id,
      uid    : props.message.id,
    })
  }

</script>